import { type SVGProps } from 'react'

type Props = SVGProps<SVGElement> & {
  alt?: string
  src?: string
}

export const IconImage = ({ alt = '', className, src }: Props) => (
  <img
    alt={alt}
    className={className}
    decoding='async'
    loading='lazy'
    role={!alt ? 'presentation' : undefined}
    src={src}
  />
)
